(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-advanced"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marquee-advanced')) {
    class MarqueeAdvanced extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.querySelector('[ref="wrapper"]');
        this.content = this.querySelector('[ref="content"]');
        this.group = this.content && this.content.querySelector('.marquee__repeated-items');
        this.mql = window.matchMedia('(max-width: 749px)');
        this._lastWidth = 0;

        this._onMqlChange = () => this.build(true);
        this.mql.addEventListener('change', this._onMqlChange);

        this._resizeObserver = new ResizeObserver(() => {
          const width = this.offsetWidth;
          if (Math.abs(width - this._lastWidth) > 1) {
            requestAnimationFrame(() => this.build(true));
          }
        });
        this._resizeObserver.observe(this);

        // Rebuild when blocks change in the theme editor
        if (window.Shopify && Shopify.designMode) {
          this._onBlockChange = () => this.build(true);
          document.addEventListener('shopify:section:load', this._onBlockChange);
          document.addEventListener('shopify:block:select', this._onBlockChange);
        }

        this.build(false);
      }

      disconnectedCallback() {
        if (this._resizeObserver) this._resizeObserver.disconnect();
        if (this.mql) this.mql.removeEventListener('change', this._onMqlChange);
        if (this._onBlockChange) {
          document.removeEventListener('shopify:section:load', this._onBlockChange);
          document.removeEventListener('shopify:block:select', this._onBlockChange);
        }
      }

      build() {
        if (!this.group || !this.content || !this.wrapper) return;

        // Remove previous clones
        this.querySelectorAll('[data-marquee-clone]').forEach((el) => el.remove());

        const containerWidth = this.offsetWidth;
        this._lastWidth = containerWidth;

        const gap = parseFloat(getComputedStyle(this.content).gap) || 0;
        const groupWidth = this.group.getBoundingClientRect().width + gap;
        if (groupWidth <= 0 || containerWidth <= 0) return;

        // Repeat the block group until one run fills the container
        const copies = Math.max(0, Math.ceil(containerWidth / groupWidth) - 1);
        for (let i = 0; i < copies; i++) {
          const clone = this.group.cloneNode(true);
          clone.setAttribute('data-marquee-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          this.content.appendChild(clone);
        }

        // Duplicate the full run once, so translating -50% loops seamlessly
        const secondHalf = this.content.cloneNode(true);
        secondHalf.setAttribute('data-marquee-clone', '');
        secondHalf.setAttribute('aria-hidden', 'true');
        this.wrapper.appendChild(secondHalf);

        // Speed is defined in px/second, so pace stays constant however long the content is
        const desktopSpeed = parseFloat(this.dataset.speed) || 50;
        const mobileSpeed = parseFloat(this.dataset.speedMobile) || desktopSpeed;
        const speed = this.mql.matches ? mobileSpeed : desktopSpeed;

        const runWidth = this.content.getBoundingClientRect().width + gap;
        const duration = runWidth / speed;
        this.style.setProperty('--marquee-speed', duration.toFixed(2) + 's');
      }
    }

    customElements.define('marquee-advanced', MarqueeAdvanced);
  }

  } catch(e) { console.error(e); }
})();
})();
